var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('div',{key:_vm.src,attrs:{"id":"google-calendar-scheduler"}},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":_vm.height,"title":"Schedule Appointment"}},[_vm._v(" Loading... ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }